mutation UpdatePlatformMenuItem($id: ID!, $input: UpdatePlatformMenuItemInput!) {
  updatePlatformMenuItem(id: $id, input: $input) {
    id
    index
    label
    linkType
    href
    targetType
    targetId
    targetTitle
    visibilityConditions {
      userType
      countries {
        type
        countryCodes
      }
      applicationPlatforms {
        type
        platforms
      }
    }
    targetUrl
    publishAt
  }
}
